export default __webpack_public_path__ + "static/media/AV-DM-2022.93535c94.pdf";